import React from 'react';
import { translation } from '../helper/translation';
import { LayoutStandardPage } from '../layout/LayoutStandardPage';
import { PartialPrivacyPolicy } from '../layout/Partial/PartialPrivacyPolicy';

export const PrivacyPolicyPage = () => {
    return (
        <LayoutStandardPage component={PartialPrivacyPolicy.toString()} />
    );
}; 